import { render, staticRenderFns } from "./addrole.vue?vue&type=template&id=4332fcc6&scoped=true"
import script from "./addrole.js?vue&type=script&lang=js&external"
export * from "./addrole.js?vue&type=script&lang=js&external"
import style0 from "./addrole.vue?vue&type=style&index=0&id=4332fcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332fcc6",
  null
  
)

export default component.exports